module.exports = __webpack_public_path__ + "img/mobile-alert.e90db398.svg";